import { ReactNode } from 'react'
import SajayaInformationConfirmByFile from '../../pages/SajayaInformationConfirm/SajayaInformationConfirmByFile'
import { UserRole } from '../../types/generalType'
import {
  AddNewPilgrim,
  CanclePreReserve,
  CitiesPreReserveStateReport,
  CompletePreReservation,
  CreatePricing,
  CreateProclamation,
  CreateProvince,
  Dashboard,
  MyInfo,
  MyPayments,
  MyPreReserve,
  PaymentReport,
  PaymentResult,
  PilgrimSearch,
  PreReserve,
  PreReserveCanceledStatDetailsReport,
  PreReserveCanceledStatReport,
  PreReserveNotPaidStatDetailsReport,
  PreReserveNotPaidStatReport,
  PreReservePaidStatDetailsReport,
  PreReservePaidStatReport,
  PreReserveStatReport,
  PreReserveStatusReport,
  PreReserveTransferDate,
  Pricing,
  Proclamation,
  Province,
  ReserveNewPreReserve,
  ResetPassword,
  SajayaRelationStateReport,
  UpdatePricing,
  UpdateProclamation,
  UpdateProvince,
  SajayaInformationConfirm
} from '../lazy/lazy'

type RouteData = {
  key: string
  roleAccess: UserRole[]
  path: string
  element: ReactNode
}
const routeData: RouteData[] = [
  // Dashboard
  {
    key: 'route-dashboard-1',
    roleAccess: [
      UserRole.AdMINISTRATOR,
      UserRole.AdminWatcher,
      UserRole.Accountant,
      UserRole.ADMIN,
      UserRole.PILGRIM,
      UserRole.PROVICEBROKER,
      UserRole.BROKER,
    ],
    path: '/',
    element: <Dashboard />,
  },
  // Proclamation
  {
    key: 'route-proclamation-1',
    roleAccess: [UserRole.AdMINISTRATOR, UserRole.AdminWatcher],
    path: '/Proclamation',
    element: <Proclamation />,
  },
  {
    key: 'route-proclamation-2',
    roleAccess: [UserRole.AdMINISTRATOR, UserRole.AdminWatcher],
    path: '/Proclamation/Create',
    element: <CreateProclamation />,
  },
  {
    key: 'route-proclamation-3',
    roleAccess: [UserRole.AdMINISTRATOR, UserRole.AdminWatcher],
    path: '/Proclamation/Update/:id',
    element: <UpdateProclamation />,
  },
  // Proclamation/Pricing
  {
    key: 'route-proclamation-1',
    roleAccess: [UserRole.AdMINISTRATOR, UserRole.AdminWatcher],
    path: '/Proclamation/:proclamationId/Pricing',
    element: <Pricing />,
  },
  {
    key: 'route-proclamation-2',
    roleAccess: [UserRole.AdMINISTRATOR, UserRole.AdminWatcher],
    path: '/Proclamation/:proclamationId/Pricing/Create',
    element: <CreatePricing />,
  },
  {
    key: 'route-proclamation-3',
    roleAccess: [UserRole.AdMINISTRATOR, UserRole.AdminWatcher],
    path: '/Proclamation/:proclamationId/Pricing/Update/:pricingId',
    element: <UpdatePricing />,
  },
  {
    key: 'route-proclamation-4',
    roleAccess: [UserRole.AdMINISTRATOR, UserRole.AdminWatcher],
    path: '/SajayaInformationConfirm',
    element: <SajayaInformationConfirm />,
  },
  // BasicInfo
  {
    key: 'route-proclamation-1',
    roleAccess: [UserRole.AdMINISTRATOR, UserRole.AdminWatcher],
    path: '/BasicInfo/Province',
    element: <Province />,
  },
  {
    key: 'route-proclamation-2',
    roleAccess: [UserRole.AdMINISTRATOR, UserRole.AdminWatcher],
    path: '/BasicInfo/Province/Create',
    element: <CreateProvince />,
  },
  {
    key: 'route-proclamation-3',
    roleAccess: [UserRole.AdMINISTRATOR, UserRole.AdminWatcher],
    path: '/BasicInfo/Province/Update/:id',
    element: <UpdateProvince />,
  },
  // PreReserve
  {
    key: 'route-prereserve-1',
    roleAccess: [UserRole.AdMINISTRATOR, UserRole.AdminWatcher, UserRole.PROVICEBROKER],
    path: '/PreReserve',
    element: <PreReserve />,
  },
  {
    key: 'route-prereserve-2',
    roleAccess: [
      UserRole.AdMINISTRATOR,
      UserRole.AdminWatcher,
      UserRole.Accountant,
      UserRole.PROVICEBROKER,
    ],
    path: '/PreReserve/CompletePreReservation/:id',
    element: <CompletePreReservation />,
  },
  {
    key: 'route-prereserve-3',
    roleAccess: [UserRole.PILGRIM],
    path: '/PreReserve/CompletePreReservation',
    element: <CompletePreReservation />,
  },
  {
    key: 'route-prereserve-4',
    roleAccess: [UserRole.PILGRIM],
    path: '/PreReserve/MyPreReserve',
    element: <MyPreReserve />,
  },
  {
    key: 'route-prereserve-5',
    roleAccess: [UserRole.PILGRIM],
    path: '/PreReserve/MyPreReserve/CompletePreReservation/:id',
    element: <CompletePreReservation />,
  },
  {
    key: 'route-prereserve-6',
    roleAccess: [UserRole.PILGRIM],
    path: '/PreReserve/MyPreReserve/Payments/:id',
    element: <MyPayments />,
  },
  {
    key: 'route-prereserve-7',
    roleAccess: [
      UserRole.AdMINISTRATOR,
      UserRole.AdminWatcher,
      UserRole.Accountant,
      UserRole.PROVICEBROKER,
    ],
    path: '/PreReserve/Payments/:id',
    element: <MyPayments />,
  },
  {
    key: 'route-prereserve-8',
    roleAccess: [UserRole.PILGRIM],
    path: '/PreReserve/MyPreReserve/Payments/:id/PaymentResult',
    element: <PaymentResult />,
  },
  {
    key: 'route-prereserve-9',
    roleAccess: [
      UserRole.AdMINISTRATOR,
      UserRole.AdminWatcher,
      UserRole.Accountant,
      UserRole.PROVICEBROKER,
    ],
    path: '/PreReserve/Payments/:id/PaymentResult',
    element: <PaymentResult />,
  },
  {
    key: 'route-prereserve-10',
    roleAccess: [
      UserRole.PILGRIM,
      UserRole.AdMINISTRATOR,
      UserRole.AdminWatcher,
      UserRole.PROVICEBROKER,
    ],
    path: '/PreReserve/PaymentResult',
    element: <PaymentResult />,
  },
  {
    key: 'route-prereserve-11',
    roleAccess: [UserRole.PILGRIM],
    path: '/PreReserve/MyPreReserve/Cancle/:id',
    element: <CanclePreReserve />,
  },
  {
    key: 'route-prereserve-12',
    roleAccess: [UserRole.AdMINISTRATOR, UserRole.AdminWatcher, UserRole.PROVICEBROKER],
    path: '/PreReserve/Cancle/:id',
    element: <CanclePreReserve />,
  },
  {
    key: 'route-prereserve-13',
    roleAccess: [UserRole.PILGRIM],
    path: '/PreReserve/ReserveNewPreReserve',
    element: <ReserveNewPreReserve />,
  },
  {
    key: 'route-prereserve-14',
    roleAccess: [UserRole.PILGRIM],
    path: '/PreReserve/ReserveNewPreReserve/NewPilgrim',
    element: <AddNewPilgrim />,
  },
  {
    key: 'route-prereserve-15',
    roleAccess: [UserRole.AdMINISTRATOR, UserRole.PROVICEBROKER],
    path: '/PreReserve/TransferDate',
    element: <PreReserveTransferDate />,
  },
  // Reset Password
  {
    key: 'route-resetPasword',
    roleAccess: [
      UserRole.AdMINISTRATOR,
      UserRole.AdminWatcher,
      UserRole.PILGRIM,
      UserRole.PROVICEBROKER,
      UserRole.ADMIN,
      UserRole.BROKER,
    ],
    path: '/ResetPassword',
    element: <ResetPassword />,
  },
  // Reset Password
  {
    key: 'route-myInfo',
    roleAccess: [UserRole.PILGRIM, UserRole.PROVICEBROKER],
    path: '/MyInfo',
    element: <MyInfo />,
  },
  // Reports
  // PreReserve Status
  {
    key: 'route-pre-reserve-status',
    roleAccess: [UserRole.AdMINISTRATOR, UserRole.AdminWatcher, UserRole.PROVICEBROKER],
    path: '/Report/PreReserveStatus',
    element: <PreReserveStatusReport />,
  },
  // PreReserve Paid Stat
  {
    key: 'route-pre-reserve-paid-stat',
    roleAccess: [
      UserRole.AdMINISTRATOR,
      UserRole.AdminWatcher,
      UserRole.Accountant,
      UserRole.PROVICEBROKER,
    ],
    path: '/Report/PreReservePaidStat',
    element: <PreReservePaidStatReport />,
  },
  // PreReserve Paid Stat Details
  {
    key: 'route-pre-reserve-paid-stat-details',
    roleAccess: [
      UserRole.AdMINISTRATOR,
      UserRole.AdminWatcher,
      UserRole.Accountant,
      UserRole.PROVICEBROKER,
    ],
    path: '/Report/PreReservePaidStatDetails',
    element: <PreReservePaidStatDetailsReport />,
  },
  // PreReserve Not Paid Stat
  {
    key: 'route-not-pre-reserve-paid-stat',
    roleAccess: [UserRole.AdMINISTRATOR, UserRole.AdminWatcher, UserRole.PROVICEBROKER],
    path: '/Report/PreReserveNotPaidStat',
    element: <PreReserveNotPaidStatReport />,
  },
  // PreReserve Not Paid Stat Details
  {
    key: 'route-not-pre-reserve-paid-stat-deatils',
    roleAccess: [UserRole.AdMINISTRATOR, UserRole.AdminWatcher, UserRole.PROVICEBROKER],
    path: '/Report/PreReserveNotPaidStatDetails',
    element: <PreReserveNotPaidStatDetailsReport />,
  },
  // PreReserve Canceled Stat
  {
    key: 'route-pre-reserve-cancled-stat',
    roleAccess: [
      UserRole.AdMINISTRATOR,
      UserRole.AdminWatcher,
      UserRole.Accountant,
      UserRole.PROVICEBROKER,
    ],
    path: '/Report/PreReserveCanceledStat',
    element: <PreReserveCanceledStatReport />,
  },
  // PreReserve Canceled Stat
  {
    key: 'route-pre-reserve-cancled-stat-details',
    roleAccess: [
      UserRole.AdMINISTRATOR,
      UserRole.AdminWatcher,
      UserRole.Accountant,
      UserRole.PROVICEBROKER,
    ],
    path: '/Report/PreReserveCanceledDetailsStat',
    element: <PreReserveCanceledStatDetailsReport />,
  },
  // PreReserve Stat
  {
    key: 'route-pre-reserve-stat',
    roleAccess: [UserRole.AdMINISTRATOR, UserRole.AdminWatcher, UserRole.PROVICEBROKER],
    path: '/Report/PreReserveStat',
    element: <PreReserveStatReport />,
  },
  // Payment Report
  {
    key: 'route-payment-report',
    roleAccess: [
      UserRole.AdMINISTRATOR,
      UserRole.AdminWatcher,
      UserRole.Accountant,
      UserRole.PROVICEBROKER,
    ],
    path: '/Report/Payment',
    element: <PaymentReport />,
  },
  // Pilgrim Search
  {
    key: 'route-pilgrim-search',
    roleAccess: [
      UserRole.AdMINISTRATOR,
      UserRole.AdminWatcher,
      UserRole.Accountant,
      UserRole.PROVICEBROKER,
    ],
    path: '/PilgrimSearch',
    element: <PilgrimSearch />,
  },
  // Payment Report
  {
    key: 'route-sajaya-relation-report',
    roleAccess: [UserRole.AdMINISTRATOR, UserRole.AdminWatcher, UserRole.PROVICEBROKER],
    path: '/Report/SajayaRelationStat',
    element: <SajayaRelationStateReport />,
  },
  {
    key: 'route-cities-prereserve-report',
    roleAccess: [UserRole.AdMINISTRATOR, UserRole.AdminWatcher, UserRole.PROVICEBROKER],
    path: '/Report/CitiesStat',
    element: <CitiesPreReserveStateReport />,
  },
]

export default routeData
